// src/components/skeletons/FilterFlightsSkeleton.jsx
import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { Button } from "@/components/ui/button";

function FilterFlightsSkeletonInner() {
  return (
    <>
      <div className="p-3 lg:p-0 flex-1 overflow-auto">
        <div className="text-xs space-y-4">
          {/* Top: count + Show All */}
          <div className="flex items-center justify-between">
            <Skeleton className="h-3 w-40" />
            <Skeleton className="h-4 w-16" />
          </div>

          {/* Accordion: Airlines */}
          <div className="border-b pb-2">
            <div className="flex items-center justify-between py-3">
              <Skeleton className="h-3 w-20" /> {/* Airlines */}
              <Skeleton className="h-4 w-4 rounded-full" />
            </div>
            <div className="space-y-2 pb-3">
              {[0, 1, 2].map((i) => (
                <div key={i} className="flex items-center space-x-2">
                  <Skeleton className="h-4 w-4 rounded" />
                  <Skeleton className="h-3 w-32" />
                </div>
              ))}
            </div>
          </div>

          {/* Accordion: Departure Time */}
          <div className="border-b pb-2">
            <div className="flex items-center justify-between py-3">
              <Skeleton className="h-3 w-24" /> {/* Departure Time */}
              <Skeleton className="h-4 w-4 rounded-full" />
            </div>
            <div className="space-y-2 pb-3">
              {[0, 1, 2].map((i) => (
                <div key={i} className="flex items-center space-x-2">
                  <Skeleton className="h-4 w-4 rounded" />
                  <Skeleton className="h-3 w-36" />
                </div>
              ))}
            </div>
          </div>

          {/* Accordion: Arrival Time */}
          <div className="border-b pb-2">
            <div className="flex items-center justify-between py-3">
              <Skeleton className="h-3 w-20" /> {/* Arrival Time */}
              <Skeleton className="h-4 w-4 rounded-full" />
            </div>
            <div className="space-y-2 pb-3">
              {[0, 1, 2].map((i) => (
                <div key={i} className="flex items-center space-x-2">
                  <Skeleton className="h-4 w-4 rounded" />
                  <Skeleton className="h-3 w-36" />
                </div>
              ))}
            </div>
          </div>

          {/* Price range slider */}
          <div className="space-y-3">
            <Skeleton className="h-3 w-24" /> {/* "Price Range" label */}
            <div className="flex items-center gap-2">
              <Skeleton className="h-5 w-5 rounded-full" />
              <div className="flex-1">
                <Skeleton className="h-2 w-full rounded-full" />
              </div>
              <Skeleton className="h-5 w-5 rounded-full" />
            </div>
            <div className="flex justify-between pt-1">
              <Skeleton className="h-3 w-20" />
              <Skeleton className="h-3 w-20" />
            </div>
          </div>

          {/* Stops section */}
          <div className="pt-3 space-y-2">
            <Skeleton className="h-3 w-16" /> {/* "Stops" heading */}
            {[0, 1, 2].map((i) => (
              <div key={i} className="flex items-center space-x-2 pb-1">
                <Skeleton className="h-4 w-4 rounded" />
                <Skeleton className="h-3 w-28" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile footer buttons (Clear / Apply) */}
      <div className="flex lg:hidden items-center shadow border-t p-3 gap-x-3 justify-end">
        <Skeleton className="h-10 w-24" />
        <Skeleton className="h-10 w-24" />
      </div>
    </>
  );
}

/**
 * Full sidebar skeleton wrapper – replaces the huge static DOM you pasted.
 * Use this where your sidebar lives.
 */
export default function FilterFlightsSidebarSkeleton() {
  return (
    <div className="hidden fixed lg:sticky top-0 left-0 z-50 bg-background w-full h-full lg:left-auto lg:top-0 lg:z-0 lg:w-auto lg:h-auto col-span-1 lg:pe-8 lg:block lg:py-6">
      <div className="flex flex-col justify-between h-dvh">
        {/* Mobile header */}
        <div className="flex lg:hidden items-center justify-between shadow border-b p-3">
          <Skeleton className="h-5 w-32" /> {/* "Filter Flights" */}
          <Skeleton className="h-10 w-10 rounded-full" />
        </div>

        {/* Inner content skeleton matching filter markup */}
        <FilterFlightsSkeletonInner />
      </div>
    </div>
  );
}
